/* eslint-disable @typescript-eslint/camelcase */
import { ConvertObjectCamelToSnakeCaseV2 } from "@/app/infrastructures/misc/common-library/ConvertObjectCamelToSnakeCase";
import { QueryParamsEntitiesV3 } from "@/domain/entities/MainApp";
import { CreateAreaPayload } from "@/domain/entities/ManageArea";
import { PaginationV2 } from "@/domain/entities/Pagination";
import { UpdatePartnerAreaRequestInterface } from '../contracts/ManageAreaRequest';
import { DetailShifts } from '@/domain/entities/ManageArea';

export class ListManageAreaApiRequest {
  page = 1;
  limit = 20;
  q = "";
  orderBy? = "";
  sort? = "";

  constructor(fields?: Partial<ListManageAreaApiRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntitiesV3(this).queryString;
  }
}

export class ListAvailableCourierApiRequest {
  page = 1;
  limit = 10;
  q = "";

  constructor(fields?: Partial<ListAvailableCourierApiRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntitiesV3(this).queryString;
  }
}

export class ListGeoAddressApiRequest {
  areaUid = "";
  q = "";
  pagination = new PaginationV2();
  sort = "ASC";
  orderBy = "province_name";

  constructor(fields?: Partial<ListGeoAddressApiRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    const { pagination, ...params } = this;
    delete pagination.totalData;

    return new QueryParamsEntitiesV3({ ...pagination, ...params }).queryString;
  }
}

export class TransferAreaApiRequest {
  originAreaUid = "";
  destinationAreaUid = "";  
  geoAddressId = [] as string[];

  constructor(fields?: Partial<TransferAreaApiRequest>) {
    Object.assign(this, fields);
  }

  toJSON() {
    return JSON.stringify(ConvertObjectCamelToSnakeCaseV2(this));
  }
}
  export class AvailableGeoAddressApiRequest {
  q = "";
  excludeAreaUid = "";

  constructor(fields?: Partial<AvailableGeoAddressApiRequest>) {
    Object.assign(this, fields);
  }

  toQueryString() {
    return new QueryParamsEntitiesV3(this).queryString;
  }
}

export class CreateAreaApiRequest {
  areas: CreateAreaPayload[] = []

  constructor(fields?: Partial<CreateAreaApiRequest>) {
    Object.assign(this, fields);
  }

  toJSON() {
    return JSON.stringify(ConvertObjectCamelToSnakeCaseV2(this));
  }
}

export class UpdatePartnerAreaRequest
  implements UpdatePartnerAreaRequestInterface {
  areaName = "";
  geoAddressIds: Array<number> = [];
  shifts: DetailShifts[] = [];

  constructor(fields: Partial<UpdatePartnerAreaRequest>) {
    Object.assign(this, fields);
  }
  toJSON(): string {
    return JSON.stringify({
      area_name: this.areaName,
      geo_address_ids: this.geoAddressIds,
      shifts: this.shifts.map((item: DetailShifts) => {
        return {
          courier_id: item.courierId,
          start_time: item.startTime,
          end_time: item.endTime
        };
      })
    });
  }
}
